import React, {useEffect } from "react";
import { Link, DeleteButton, showNotification, refreshView  } from "react-admin";
import moment from "moment";
import styled from "styled-components";
import ClientInformation from "./clientInformation";
import ClientsEmails from "./clientsEmails";
import TourBookingFormButton from "./tourBookingForm";

import {
  concat,
  groupBy,
  sortWith,
  ascend,
  path,
  head,
  isEmpty,
  values,
  propEq,
  filter,
  isNil,
  map,
  trim,
  curry,
  length,
  any,
  chain,
  prop,
  init,
  last,
  append,
  ap,
  identity,
  sum,
  mergeWith,
  mapObjIndexed,
  where,
  flatten,
} from "ramda";

import { connect } from "react-redux";
import GenericWhiteboard from "./genericWhiteboard";
import Cake from "@material-ui/icons/Cake";
import BeachAccess from "@material-ui/icons/BeachAccess";
import ExploreOutlined from "@material-ui/icons/ExploreOutlined";
import { withStyles } from "@material-ui/core/styles";
import Description from "@material-ui/icons/Description";
import Print from "@material-ui/icons/Print";
import Navigation from "@material-ui/icons/Navigation";
import Pantool from "@material-ui/icons/PanTool";
import Polymer from "@material-ui/icons/Polymer";
import Face from "@material-ui/icons/Face";
import EventSeat from "@material-ui/icons/EventSeat";
import SimplePopOver from "./simplePopOver";
import LocalGasStation from "@material-ui/icons/LocalGasStation";
import Info from "@material-ui/icons/Info";
import DirectionsBus from "@material-ui/icons/DirectionsBus";
/* import Speed from "@material-ui/icons/Speed"; */
import MoodBad from "@material-ui/icons/MoodBad";
import Group from "@material-ui/icons/Group";
import Person from "@material-ui/icons/Person";
import Cancel from "@material-ui/icons/Cancel";
import PersonPin from "@material-ui/icons/PersonPin";
import PostAddIcon from '@material-ui/icons/PostAdd';
import FolderShared from "@material-ui/icons/FolderShared";

import { API_ROOT } from "../api-config";
import { isNull } from "util";
import moment_tz from 'moment-timezone';

import { canAccess } from "../rbac";
import ClientDocumentsModal from "./ClientDocumentsModal";
import { documentTarget } from "../utils/agencyRiderDocuments";
import ProfileCompleteMark from "./profileCompleteMark";

const styles = theme => ({
  root: {
    ...theme.mixins.gutters(),
    paddingTop: theme.spacing.unit * 2,
    paddingBottom: theme.spacing.unit * 2
  }
});
moment_tz.tz.setDefault("Europe/Madrid");
const StyledLink = styled(Link)`
  color: #000000 !important;
`;

const StyledExplore = styled(ExploreOutlined)`
  font-size: 35px !important;
`;

const StyledGroupOptions = styled.div({
  display: "flex",
  flexDirection: "row",
  justifyContent: "flex-end"
});

const Card = styled.div(props => ({
  paddingTpp: "0.3em",
  paddingLeft: "0.1em",
  paddingRight: "0.1em",
  backgroundColor: props.color,
  borderBottom: "2px solid black"
}));

const Header = styled.div({
  display: "flex",
  flexDirection: "column"
});

const HeaderDays = styled.div({
  justifyContent: "space-between",
  flexDirection: "row",
  display: "flex"
});

const HeaderDay = styled.div(props => ({
  textAlign: "center",
  backgroundColor: props.color
}));

const HeaderName = styled.div({
  textAlign: "center",
  fontWeight: "bold"
});

const StyledDivClient = styled.div({
  display: "flex",
  flexDirection: "row",
  justifyContent: "start !important",
  alignItems: "center"
});

const StyledDivBike = styled.div({
  // paddingTop: "20px",
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "flex-end"
  // width: "150px"
});

const HeaderDesc = styled.div({
  marginTop: "5px",
  marginBottom: "5px",
  textAlign: "center",
  backgroundColor: "#ffffff !important",
  fontSize: "13px",
  color: "#000000",
  padding: "5px"
});

const HeaderDate = styled.div({
  textAlign: "center"
});

const Name = styled.span({});

const Column = styled.div(props => ({
  fontSize: "15px",
  // marginBottom: "0.5rem",
  marginTop: "0.5rem",
  marginRight: "0.5rem",
  display: "flex",
  flexDirection: "column",
  // width: "150px",
  textAlign: "right"
}));

const ColumnSummary = styled.div(props => ({
  borderTop: "1px solid black",
  fontSize: "15px",
  paddingTop: "0.5rem",
  paddingBottom: "0.5rem",
  display: "flex",
  flexDirection: "column"
}));

const ColumnSummaryGuide = styled.div(props => ({
  fontSize: "15px",
  paddingBottom: "0.5rem",
  display: "flex",
  borderTop: props.noBorder === "yes" ? "" : "1px solid black",
  alignItems: props.isRow === "yes" ? "center" : "left",
  flexDirection: props.isRow === "yes" ? "row" : "column"
}));

const Row = styled.div({
  flexGrow: "1",
  fontSize: "15px",
  marginTop: "0.5rem"
});

const RowDriverPassengerBike = styled.div({
  flexGrow: "1",
  fontSize: "15px",
  paddingTop: "0.5rem",
  paddingBottom: "0.5rem",
  display: "flex",
  alignItems: "baseline",
  justifyContent: "space-between"
});

const RowDetails = styled.div({
  display: "flex"
});

const ColumnGuideIl = styled.div({
  display: "flex",
  width: "40%",
  alignItems: "start",
  marginTop: "0.5rem",
  marginRight: "0.5rem"
});

const ColumnGuideIrC = styled.div({
  display: "flex",
  width: "60%",
  flexDirection: "column",
  marginTop: "0.5rem",
  marginRight: "0.5rem"
});

const ColumnGuideIr = styled.div({
  flexDirection: "row",
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end"
});

const RentalOptions = styled.div({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  textAlign: "left"
});

class TourCard extends React.Component {

  state = {
    guide : true,
    miga: 'tours',
    clientDocumentsModalOpen: false,
    documentsClientId: null,
    documentsRentalId: null,
  }

  openClientDocuments = (clientId, booking, rentalId, e) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    const target = documentTarget({
      id: rentalId,
      client_id: clientId,
      booking_id: booking && booking.id,
      date_1: rentalId ? 1 : null,
      booking: booking,
    });
    if (!target.clientId && !target.rentalId) return;
    this.setState({
      clientDocumentsModalOpen: true,
      documentsClientId: target.clientId,
      documentsRentalId: target.rentalId,
    });
  }

  closeClientDocuments = () => {
    this.setState({
      clientDocumentsModalOpen: false,
      documentsClientId: null,
      documentsRentalId: null,
    });
  }

  openPdfByRentalDayAndLocation = async (rentalDay, locationId) => {
    await fetch(
      `${API_ROOT}/generate_rental_contract/?type=1&location_id=${locationId}&day=${moment(
        rentalDay
      ).format("YYYY-MM-DD")}`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.token}`
        }
      }
    )
      .then(async res => {
        const file = await res.blob();

        var reader = new FileReader();
        reader.readAsDataURL(file); //Convert the blob from clipboard to base64
        reader.onload = function (event) {
          const pdfDoc = reader.result.replace("octet-stream", "pdf");
          let a = document.createElement("a");
          a.href = pdfDoc;
          a.download = `tour-${moment(rentalDay).format("YYYY-MM-DD")}.pdf`;
          a.click();
          a.remove();
        };
      })

      .catch(err => {
        console.error(err);
      });
  };

  buildLinkContracts = (rentalDay, locationId) => {
    return (
      <div>
        <Link
          to="#"
          alt="View all Contracts"
          title="View all Contracts"
          onClick={() =>
            this.openPdfByRentalDayAndLocation(rentalDay, locationId)
          }
        >
          <Print />
        </Link>
      </div>
    );
  };

  openPdfByRentalId = async tour => {
    await fetch(`${API_ROOT}/generate_rental_contract/${tour.id}?type=1`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.token}`
      }
    })
      .then(async res => {
        const file = await res.blob();

        var reader = new FileReader();
        reader.readAsDataURL(file); //Convert the blob from clipboard to base64
        reader.onload = async function (event) {
          const pdfDoc = reader.result.replace("octet-stream", "pdf");
          let a = document.createElement("a");
          a.href = pdfDoc;
          a.download = `tour-${tour.id}.pdf`;
          a.click();
          a.remove();
        };
      })

      .catch(err => {
        console.error(err);
      });
  };
  buildLinkContract = tour => {
    return (
      <Link
        to="#"
        alt="View Contract"
        title="View Contract"
        onClick={() => this.openPdfByRentalId(tour)}
      >
        <Print />
      </Link>
    );
  };

  isSingle = tour => length(tour.single) > 0;
  isVip = tour => any(propEq("insurance_description", "VIP"), tour.insurance);
  hasDevice = tour => length(tour.device) > 0;
  hasSeat = tour => length(tour.seat) > 0;
  hasJacket = tour => length(tour.jacket) > 0;
  hasHelmet = tour => length(tour.helmet) > 0;
  hasTankgbag = tour => length(tour.tankbag) > 0;
  hasGlove = tour => length(tour.glove) > 0;
  hasInsurance = tour =>
    any(propEq("insurance_description", "Cancel Insurance"), tour.insurance);
  isDocumentation = tour => length(tour.r_documentacion) > 0;

  renderRoomDetail = tour => {
    if (this.isSingle(tour)) {
      return (
        <SimplePopOver
          key={`single_${tour.id}`}
          itemText="Has Single Room"
          items={tour.single}
          iconImage={Person}
        />
      );
    } else {
      return (
        <SimplePopOver
          key={`single_${tour.id}`}
          itemText="Has Double Room"
          items={[{ double: true }]}
          iconImage={Group}
        />
      );
    }
  };

  renderVip = tour => {
    if (this.isVip(tour)) {
      const vip = filter(
        where({
          insurance_description: insurance_description =>
            insurance_description === "VIP"
        }),
        tour.insurance
      );

      return (
        <SimplePopOver
          key={`vip_${tour.id}`}
          itemText="Has VIP insurance"
          items={vip}
          iconImage={PersonPin}
        />
      );
    }
  };

  renderDevice = tour => {
    if (this.hasDevice(tour)) {
      return (
        <SimplePopOver
          key={`gps_${tour.id}`}
          itemText="Selected gps"
          items={tour.device}
          iconImage={Navigation}
        />
      );
    }
  };

  renderSeat = tour => {
    if (this.hasSeat(tour)) {
      return (
        <SimplePopOver
          key={`seat_${tour.id}`}
          itemText="Has low seat"
          items={tour.seat}
          iconImage={EventSeat}
        />
      );
    }
  };

  renderTankbag = tour => {
    if (this.hasTankgbag(tour)) {
      return (
        <SimplePopOver
          key={`tb_${tour.id}`}
          itemText="Has tankbag"
          items={tour.tankbag}
          iconImage={LocalGasStation}
        />
      );
    }
  };

  renderGlove = tour => {
    if (this.hasGlove(tour)) {
      return (
        <SimplePopOver
          key={`gl_${tour.id}`}
          itemText="Has gloves"
          items={tour.glove}
          iconImage={Pantool}
        />
      );
    }
  };

  renderHelmet = tour => {
    if (this.hasHelmet(tour)) {
      return (
        <SimplePopOver
          key={`hl_${tour.id}`}
          itemText="Has helmet"
          items={tour.helmet}
          iconImage={Face}
        />
      );
    }
  };

  renderJacket = tour => {
    if (this.hasJacket(tour)) {
      return (
        <SimplePopOver
          key={`jc_${tour.id}`}
          itemText="Has jacket"
          items={tour.jacket}
          iconImage={Polymer}
        />
      );
    }
  };

  renderInsurance = tour => {
    if (this.hasInsurance(tour)) {
      return (
        <SimplePopOver
          key={`jc_${tour.id}`}
          itemText="Has cancel insurance"
          items={tour.insurance}
          iconImage={BeachAccess}
        />
      );
    }
  };

renderDocumentation = tour => {
  console.log('r_documentacion', tour.id, tour.r_documentacion, typeof tour.r_documentacion);

  const val = tour.r_documentacion;
  const hasDocs = val === true || val === 1 || val === '1' || val === 'true';

  if (!hasDocs) return null;

  return (
    <SimplePopOver
      key={`jc_${tour.id}`}
      itemText="Documents received"
      items={["Documents received"]} // <-- pasar array, no boolean
      iconImage={PostAddIcon}
    />
  );
};

  renderSeparators = (components, separator) => {
    const addSeparator = component => [component, separator];
    return append(last(components), chain(addSeparator, init(components)));
  };

  renderDetails = tour => {
    const details = filter(
      identity,
      ap(
        [
          this.renderRoomDetail,
          this.renderVip,
          this.renderDevice,
          this.renderSeat,
          this.renderTankbag,
          this.renderInsurance,
          this.renderGlove,
          this.renderHelmet,
          this.renderJacket,
          this.renderDocumentation
        ],
        [tour]
      )
    );
    return (
      <RowDetails key={tour.id}>
        {this.renderSeparators(details, <React.Fragment></React.Fragment>)}
      </RowDetails>
    );
  };

  renderBirthdayIfNeeded = (person, clientBirthday, tour_start, tour_end) => {
    const start = moment(tour_start);
    const end = moment(tour_end);

    const birthday = moment(clientBirthday).set("year", end.year());

    const dateBday = moment.utc(clientBirthday);
    if (birthday.isBetween(start, end, null, [])) {
      return (
        <SimplePopOver
          key={`bday_${person ? person.id : "booking_pass"}`}
          itemText={`Birthday date: ${dateBday.format("YYYY-MM-DD")}`}
          items={[{ birthday: true }]}
          iconImage={Cake}
        />
      );
    }
  };

  howManyTours = (person, tour_end) => {
    if (!person) return "";
    const howMany = prop("rentals", person) || [];
    const howManyP = prop("passenger", person) || [];

    const manySg = filter(obj => obj.booking.tour.self_guided && moment(obj.booking.tour.tour_start_date).isBefore(moment(tour_end)), howMany);
    const manyNsg = filter(obj =>!obj.booking.tour.self_guided && moment(obj.booking.tour.tour_start_date).isBefore(moment(tour_end)), howMany);
    
    const manyPsg = filter(obj => obj.booking.tour.self_guided && moment(obj.booking.tour.tour_start_date).isBefore(moment(tour_end)), howManyP);
    const manyPnSg = filter(obj =>!obj.booking.tour.self_guided && moment(obj.booking.tour.tour_start_date).isBefore(moment(tour_end)), howManyP);


    if (isEmpty(howMany) && isEmpty(howManyP)) {
      return "";
    } else {
      return (
        <b>
          ({manyNsg.length + manyPnSg.length})({manySg.length + manyPsg.length})
        </b>
      );
    }
  };

  renderPerson = (tour_start, tour_end, tourId, booking, isRider, clientId, person) => {
    return (
      <StyledDivClient>
        <Name>
          <StyledLink
            to={{ 
                pathname: `/tour_clients/${tourId}/show`, 
                search:  `?from=tours`,
            }}
            //target="_blank"
          >
            {isRider ? booking.r_first_name + " " + booking.r_last_name : booking.p_first_name + " " + booking.p_last_name}
            {isRider && booking.nickname ? ` (${booking.nickname})` : ''}
       
            {!isRider && person && person.nickname ? ` (${person.nickname})` : ''}
          </StyledLink>{" "}
          {this.howManyTours(person, tour_end)}
          {clientId ? (
            <span
              title="View / upload client documents"
              alt="View / upload client documents"
              onClick={e => this.openClientDocuments(clientId, booking, tourId, e)}
              style={{
                cursor: "pointer",
                marginLeft: 4,
                display: "inline-flex",
                verticalAlign: "middle",
                color: "#555",
              }}
            >
              <FolderShared style={{ fontSize: 18 }} />
            </span>
          ) : null}
        </Name>
        {this.renderBirthdayIfNeeded(person, isRider ? booking.r_birthday : booking.p_birthday, tour_start, tour_end)}
      </StyledDivClient>
    );
  };

  renderRow = (tour_start, tour_end, rental) => {
    const riderClientId = rental.client_id || path(["driver", "id"], rental);

    const renderRider = curry(this.renderPerson)(
      tour_start,
      tour_end,
      rental.id,
      rental.booking,
      true,
      riderClientId
    );

    const renderPassenger = curry(this.renderPerson)(
      tour_start,
      tour_end,
      rental.id,
      rental.booking,
      false
    );

    const ShowRentalLink = () => {
      return (
        <Link
          to={{
            pathname: `/tour_clients/${rental.id}/show`, 
            search:  `?from=tours`,
          }}
          //target="_blank"
        >
          <Description />
        </Link>
      );
    };

    
    const EditRentalLink = () => {
      let date1 = new Date(rental.date_1);
      let date2 = new Date();
      let statusCancel = false
      //si el rental tour date1 es mayor a la fecha actual muestra boton cancel
      if (date1 > date2) {
        statusCancel = true
      }

      const handleClick = () => { 
           window.location.reload();
      };

      return (
        <DeleteButton className={`deleteButton`} style={{ backgroundColor: 'transparent', paddingTop: '-10px', marginTop: '-10px', minWidth: '0px', minHeight: '0px' }} 
        basePath="tours" redirect={handleClick} resource="rentals" label=""  record={rental}
        hidden={statusCancel === true ? true : false}
        undoable={false} refresh={true} onClick={handleClick}
        alt="Cancel tour"
        title="Cancel tour"
        />
      );
    };
    const AddDamageButton = () => {
      if (rental.vehicle[0] !== undefined) {
        return (
          <Link
            to={{
              pathname: `/vehicle_damages/create`,
              search: `?client_id=${rental.client_id}&rental_id=${rental.id}&vehicle_id=${rental.vehicle[0].id}&from=tours`,
              state: { miga: 'tours'},
            }}
            state={{ miga: "tours"}}
            alt="Add Damage"
            title="Add Damage"
            //target="_blank"
          >
            <MoodBad />
          </Link>
        );
      } else {
        return <React.Fragment />;
      }
    };

    const AddKmsButton = () => {
      if (rental.vehicle[0] !== undefined) {
        return (
          <Link
            to={{
              pathname: canAccess("unentered_km_rentals") ?  `/unentered_km_rentals/${rental.id}` : '',
              search: `?from=tours`,
              state: { miga: 'tours'},
            }}
            state={{ miga: "tours"}}
            //target="_blank"
            alt="Add kms"
            title="Add kms"
          >
            Speed{/* <Speed /> */}
          </Link>
        );
      } else {
        return <React.Fragment />;
      }
    };

    const efectiveEndDate = moment(tour_end, "YYYY-MM-DD").add(1, "day");
    const diffEjecucionRental = efectiveEndDate.diff(moment(), 'days')

    const passengerClientsForDisplay = (() => {
      if (!isEmpty(rental.passenger)) return rental.passenger;
      const pFirst = prop("p_first_name", rental.booking);
      if (pFirst != null && trim(String(pFirst)) !== "") return [null];
      return [];
    })();

    return (
      <React.Fragment>
        <Row key={rental.id} style={{ borderTop: "1px solid black" }}>
          {renderRider(rental.driver)}{" "}
          {map(
            passenger => renderPassenger(prop("id", passenger), passenger),
            passengerClientsForDisplay
          )}
        </Row>
        <RowDriverPassengerBike style={{ alignItems: "flex-start" }}>
          <Column>
            <div
              style={{
                display: "flex",
                flexDirection: "row"
              }}
            >
              {this.renderDetails(rental)}
            </div>
          </Column>
          <Column>
            {isEmpty(rental.vehicle) && (
              <StyledDivBike>Own Motorcycle</StyledDivBike>
            )}
            {!isEmpty(rental.vehicle) && (
              <StyledDivBike>
                {rental.vehicle[0].model.model_name}
                {
                  <SimplePopOver
                    key={`rental_iv_${rental.id}`}
                    itemText=""
                    items={[
                      { model: `Color: ${rental.vehicle[0].vehicle_color}` },
                      { model: `KM: ${rental.vehicle[0].vehicle_mileage}` }
                    ]}
                    iconImage={Info}
                  />
                }
              </StyledDivBike>
            )}
            {!isEmpty(rental.vehicle) && rental.vehicle[0].licence_plate} <br />
          </Column>
        </RowDriverPassengerBike>
        <RowDriverPassengerBike>
          <Column>
            <RentalOptions>
              <TourBookingFormButton bookingId={rental.booking_id} />
              {this.buildLinkContract(rental)}
              <ShowRentalLink />
              <ProfileCompleteMark record={rental} />
              {diffEjecucionRental < 1 && <AddDamageButton />}
              {diffEjecucionRental > 1 && <EditRentalLink />}
              {diffEjecucionRental < 1 && <AddKmsButton />}
              {/* {efectiveEndDate.isBefore(moment(moment(), "YYYY-MM-DD")) && (
                              <AddKmsButton />
              )} */}
            </RentalOptions>
          </Column>
        </RowDriverPassengerBike>
      </React.Fragment>
    );
  };

  renderGuide = guide => {
    return (
      <ColumnSummaryGuide id={guide.id} isRow="yes">
        <ColumnGuideIl>
          {!guide.TourGuide.briefing_guide ? "TOUR GUIDE" : "BRIEFING GUIDE"}:{" "}
        </ColumnGuideIl>
        <ColumnGuideIrC>
          <ColumnGuideIr>{guide.name}</ColumnGuideIr>
        </ColumnGuideIrC>
      </ColumnSummaryGuide>
    );
  };

  renderItem = items => {
    return values(
      map(item => {
        return <div id={item.id}>Item: {item.model}</div>;
      }, items)
    );
  };

  renderGpsGuide = gps => (
    <ColumnSummaryGuide id={gps.id} isRow="yes">
      <ColumnGuideIl>GUIDE GPS:</ColumnGuideIl>
      <ColumnGuideIrC>
        <ColumnGuideIr>
          {head(gps.model.split("("))}
          <SimplePopOver
            key={`rental_iv_${gps.id}`}
            itemText="Guide Gps"
            items={[{ model: gps.model }]}
            iconImage={Info}
          />
        </ColumnGuideIr>
      </ColumnGuideIrC>
    </ColumnSummaryGuide>
  );

  renderGuideVehicle = (tour_end_date, tour_id, vehicle) => {
    const efectiveEndDate = moment(tour_end_date, "YYYY-MM-DD").add(1, "day");
    const AddKmsTourVehicle = () => {
      return (
        <Link
          to={{
            pathname: `${vehicle.model.vehicle_type_id === 1
              ? "unentered_km_tour_vans"
              : "unentered_km_tour_bikes"
              }/${vehicle.model.vehicle_type_id === 1
                ? vehicle.TourVan.id
                : vehicle.TourBike.id
              }`,
            state: { miga: "tours"}
          }}
          state={{ miga: "tours"}}
          //target="_blank"
          alt="Add kms"
          title="Add kms"
        >
          {/* <Speed /> */}
        </Link>
      );
    };
    const AddDamageButton = () => {
     // console.log(this.props)
     // if (vehicle.vehicle[0] !== undefined) {
       return (
          <Link
            to={{
              pathname: `/vehicle_damages/create`,
              search: `?client_id=${74}&vehicle_id=${vehicle.id}&from=toursW&guide=${this.state.guide}`
            }}
            alt="Add Damage"
            title="Add Damage"
            //target="_blank"
          >
            <MoodBad />
          </Link>
        );
     // } else {
     //   return <React.Fragment />;
     // }
    };
    return (
      <React.Fragment>
        <ColumnSummaryGuide
          id={vehicle.id}
          key={`${vehicle.id}_${tour_id}`}
          isRow="yes"
        >
          <ColumnGuideIl>
            {vehicle.model.vehicle_type_id === 1
              ? "GUIDE VAN:  "
              : "GUIDE BIKE:  "}
          </ColumnGuideIl>
          <ColumnGuideIrC>
            <ColumnGuideIr>
              {vehicle.model.model_name}
              <SimplePopOver
                key={`rental_iv_${tour_id}`}
                itemText=""
                items={[
                  {
                    model: `Color: ${vehicle.color ? vehicle.color : "white"}`
                  },
                  { model: `KM: ${vehicle.vehicle_mileage}` }
                ]}
                iconImage={Info}
              />
            </ColumnGuideIr>
            <ColumnGuideIr>{vehicle.licence_plate} {vehicle.renting ? "®" : ""}</ColumnGuideIr>
          </ColumnGuideIrC>
        </ColumnSummaryGuide>
        <ColumnSummaryGuide
          id={vehicle.id}
          key={`x_${vehicle.id}_${tour_id}`}
          isRow="yes"
          noBorder="yes"
        >
          <RentalOptions>
            {efectiveEndDate.isBefore(moment(moment(), "YYYY-MM-DD")) && (
              <AddKmsTourVehicle />
            )}
            {efectiveEndDate.isBefore(moment()) && <AddDamageButton />}
          </RentalOptions>
        </ColumnSummaryGuide>
      </React.Fragment>
    );
  };

  renderSummary = tour => {
    const passengerCountForRental = rental => {
      const linked = length(rental.passenger);
      if (linked > 0) return linked;
      const pFirst = prop("p_first_name", rental.booking);
      return pFirst != null && trim(String(pFirst)) !== "" ? 1 : 0;
    };
    const personsForRental = rental => 1 + passengerCountForRental(rental);
    const numberOfPersons = sum(map(personsForRental, tour.rentals));

    const numberOfRentedBikes = length(tour.rentals); //filter own bikes
    const numberOfGuideBikes = length(tour.bikes);

    const isSingleRoom = rental => length(rental.single) > 0;
    const isGps = rental => length(rental.device) > 0;

    const numberOfGpsDevicesGuides = length(tour.gps_devices);
    const numberOfGpsDevices =
      length(filter(isGps, tour.rentals)) + numberOfGpsDevicesGuides;

    const numberOfSingleRooms = length(filter(isSingleRoom, tour.rentals));
    const numberOfDoubleRooms = length(tour.rentals) - numberOfSingleRooms;

    const bikesByModel = groupBy(rental => {
      return !isEmpty(rental.vehicle)
        ? rental.vehicle[0].model.model_name
        : "Own Motorcycle";
    }, tour.rentals);

    const guideBikesByModel = groupBy(vehicle => {
      return vehicle.model.model_name;
    }, tour.bikes);

    const allBikes = mergeWith(concat, bikesByModel, guideBikesByModel);

    const bikes = values(
      mapObjIndexed((bikes, model) => {
        const numberOfGuidesWithModel = length(guideBikesByModel[model]);
        return (
          <div>
            <span>
              {" "}
              * {length(bikes)} {model}{" "}
            </span>
            {numberOfGuidesWithModel > 0 ? (
              <span> ({numberOfGuidesWithModel} guide) </span>
            ) : null}
          </div>
        );
      }, allBikes)
    );

    const getEmails = () => {
      const emails = [];
      map(rental => {
        const booking = rental.booking;

        // Rider
        emails.push({
          clientId: path(["driver", "id"], rental),
          email: prop("r_email", booking),
          language: prop("language", booking) || path(["driver", "language"], rental),
          name: `${prop("r_first_name", booking)} ${prop("r_last_name", booking)}`
        });

        // Passenger
        if (!isNil(prop("p_email", booking)) && !isEmpty(prop("p_email", booking))) {
          emails.push({
            clientId: prop("id", head(prop("passenger", rental))),
            email: prop("p_email", booking),
            language: prop("language", booking) || prop("language", head(prop("passenger", rental))),
            name: `${prop("p_first_name", booking)} ${prop("p_last_name", booking)}`
          });
        }
      }, tour.rentals);

      return emails;
    };

    const emails = getEmails();

    const sortedEmails = sortWith(
      [ascend(prop("language_id")), ascend(prop("name"))],
      emails
    );

    // const sortedEmails = uniqBy(
    //   prop("email"),
    //   sortWith([ascend(prop("language_id")), ascend(prop("name"))], emails)
    // );

    return (
      <div>
        <React.Fragment>{map(this.renderGuide, tour.guides)}</React.Fragment>
        <React.Fragment>
          {map(
            curry(this.renderGuideVehicle)(tour.tour_end_date, tour.id),
            tour.bikes
          )}
        </React.Fragment>
        <React.Fragment>
          {map(this.renderGpsGuide, tour.gps_devices)}
        </React.Fragment>
        <React.Fragment>
          {map(
            curry(this.renderGuideVehicle)(tour.tour_end_date, tour.id),
            tour.vans
          )}
        </React.Fragment>
        <ColumnSummary>
          <h4>Summary</h4>
          {numberOfPersons} persons.
          {numberOfRentedBikes} bikes + {numberOfGuideBikes} guide ={" "}
          {numberOfRentedBikes + numberOfGuideBikes} bikes.
          {bikes}
          {numberOfDoubleRooms} Double, {numberOfSingleRooms} Single
          <br />
          {numberOfGpsDevices} GPS devices + {numberOfGpsDevicesGuides} guide
          <StyledGroupOptions>
            {tour.rentals.length > 1 ? (
              this.buildLinkContracts(tour.tour_start_date, tour.location_1.id)
            ) : (
              <span>&nbsp;</span>
            )}
            <ClientInformation
              clientIds={map(item => item.client_id, tour.rentals)}
            />
            <SimplePopOver
              key={`tourbus_${tour.id}`}
              itemName="client_first_name"
              itemText="Clients on bus:"
              items={tour.van_passengers}
              iconImage={DirectionsBus}
            />

            <ClientsEmails data={sortedEmails} />
          </StyledGroupOptions>
        </ColumnSummary>
      </div>
    );
  };

  render() {
    const {
      id,
      tour_start_date,
      tour_end_date,
      location_1,
      location_2,
      rentals,
      tour_name,
      tour_category_id,
      mode_tour,
      self_guided
    } = this.props;

    const sortedRentals = sortWith(
      [
        ascend(path(["vehicle", 0, "model", "order"])),
        ascend(path(["booking", "r_first_name"]))
      ],
      rentals
    );

    return (
      <Card color={trim(location_1.color)} key={id} raised={true} spacing={0}>
        <Header>
          <HeaderDays>
            <HeaderDay>
              {moment(tour_start_date).format("DD")} (
              {moment(tour_start_date)
                .format("MMM")
                .toUpperCase()}
              )
            </HeaderDay>
            <HeaderDay color={trim(location_2.color)}>
              {moment(tour_end_date).format("DD")} (
              {moment(tour_end_date)
                .format("MMM")
                .toUpperCase()}
              )
            </HeaderDay>
          </HeaderDays>
          <HeaderName>
            <StyledLink to={{ pathname: `/tours/${id}` }}> 
              {(mode_tour === false || mode_tour === null) && (
                <React.Fragment>
                  <p style={{
                          backgroundColor: "#FDB813", 
                          color: "#FFFFFF" , 
                          display: "inline-block",
                          padding: "7px 13px", 
                          borderRadius: "50%", 
                          textAlign: "center", 
                          fontWeight: "bold", 
                          width: "auto",
                          margin: "3px", 
                        }}><strong> T </strong></p>  
                </React.Fragment> 
              )}
              {mode_tour === true && (
                <React.Fragment>
                   <p style={{
                          backgroundColor: "#757575", 
                          color: "#FFFFFF" , 
                          display: "inline-block",
                          padding: "7px 13px", 
                          borderRadius: "50%", 
                          textAlign: "center", 
                          fontWeight: "bold", 
                          width: "auto",
                          margin: "3px", 
                        }}><strong> P </strong></p>  
                </React.Fragment> 
              )}
              {tour_name && tour_name.tour_name_en}
            </StyledLink>
          </HeaderName>
          <HeaderDate>
            {moment(tour_start_date).format("MMM D")} -{" "}
            {moment(tour_end_date).format("MM") ===
              moment(tour_start_date).format("MM")
              ? moment(tour_end_date).format("D YYYY")
              : moment(tour_end_date).format("MMM D YYYY")}
          </HeaderDate>
          { tour_name  && !isNull(tour_name.tour_desc) && <HeaderDesc>{tour_name.tour_desc}</HeaderDesc> }
          {self_guided && (
            <HeaderName>
              <StyledExplore />
            </HeaderName>
          )}
        </Header>
        {map(
          curry(this.renderRow)(tour_start_date, tour_end_date),
          sortedRentals
        )}
        {this.renderSummary(this.props)}
        <ClientDocumentsModal
          open={this.state.clientDocumentsModalOpen}
          onClose={this.closeClientDocuments}
          clientId={this.state.documentsClientId}
          rentalId={this.state.documentsRentalId}
        />
      </Card>
    );
  }
}

const ToursWhiteboard = props => (
  <GenericWhiteboard
    title="Tours"
    resource="tours"
    dateField="tour_start_date"
    card={TourCard}
    createUrl={"#/tours/create"}
  />
);

const mapStateToProps = function (state) {
  return {
    state: state
  };
};

export default withStyles(styles)(connect(mapStateToProps)(ToursWhiteboard));



// WEBPACK FOOTER //
// ./src/components/toursWhiteboard.js